/**
 * パスワードポリシー (Cognito ユーザープールの passwordPolicy と揃える)。
 *
 * lib/oba-core-stack.ts の passwordPolicy:
 *   minLength: 12 / requireLowercase / requireUppercase / requireDigits (記号は不要)
 */
export const PASSWORD_MIN_LENGTH = 12;

export interface PasswordRule {
  id: 'minLength' | 'lowercase' | 'uppercase' | 'digit';
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: readonly PasswordRule[] = [
  {
    id: 'minLength',
    label: `${PASSWORD_MIN_LENGTH}文字以上`,
    test: (p) => p.length >= PASSWORD_MIN_LENGTH,
  },
  { id: 'lowercase', label: '英小文字を含む', test: (p) => /[a-z]/.test(p) },
  { id: 'uppercase', label: '英大文字を含む', test: (p) => /[A-Z]/.test(p) },
  { id: 'digit', label: '数字を含む', test: (p) => /[0-9]/.test(p) },
];

/** 全ての条件を満たしているか */
export function isPasswordValid(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}
